import { Component, OnInit, Pipe, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import axios from 'axios';
import { TokenService } from 'src/app/auth/token.service';
import { EditorService } from 'src/app/components/editor/editor.service';
declare var $: any;

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css']
})
export class ViewComponent implements OnInit {
  job: any = {};
  viewType: any = 0;
  manualChannel: any = {};
  username: any = null;
  usertoken: any = null;
  limit: any = 5;
  isLoading: any = false;
  queryParam: any = null;
  reqType: any = 'views';

  constructor(private snackBar: MatSnackBar, private activatedRoute: ActivatedRoute, private tokenService: TokenService, private editorService: EditorService) { }

  ngOnInit(): void {
    this.username = this.tokenService.getUsername();
    this.usertoken = this.tokenService.getToken();
    axios.defaults.headers.common['aux'] = this.usertoken;
    this.queryParam = this.activatedRoute.snapshot.queryParamMap.get('view');
    if (!this.queryParam) {
      this.getChannels();
    } else {
      this.viewType = 2;
      this.limit = 20;
      let [chanel_id, chanel_name] = this.queryParam.split(',');
      this.manualChannel = { chanel_id, chanel_name };
      this.job[chanel_id] = { results: [], page: 1 };
      this.getJobByChannel(this.manualChannel);
    }

    $(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }

  openSnackBar(message: any, duration: any = 3000) {
    this.snackBar.open(message, '', {
      duration: duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'bg-primary'
    });
  }

  getJobByChannel(channel: any = null, name: any = null, page: any = 1) {
    const that = this;
    this.isLoading = true;
    let lst_channel = channel.chanel_id == 'search' ? this.manualChannel.chanel_id ? this.manualChannel.chanel_id : null : channel.chanel_id;
    let uri = encodeURIComponent(`${environment.magic}/job/${this.reqType}/${this.username}/${name}/${lst_channel}/${this.limit}/${page}`);
    axios.get(`/pass/${uri}`)
      .then((response) => {
        if (response.data.length) {
          response.data = response.data.map(e => {
            if (e.reup_config) e.reup_config = JSON.parse(e.reup_config);
            return e;
          })
          that.job[channel.chanel_id].results = [...that.job[channel.chanel_id].results, ...response.data];
          that.job[channel.chanel_id].page = page;
          if (channel.chanel_name != null) {
            if (!that.job.hasOwnProperty('stats')) that.job.stats = [];
            let stat = { chanel_id: channel.chanel_id, chanel_name: channel.chanel_name, error_count: that.job[channel.chanel_id].results.slice(0, 5).filter(x => (x.success != null && x.success != 1) || (x.upload_status != 0 && x.upload_status != 3)).length };
            const index = that.job.stats.findIndex(x => x.chanel_name == channel.chanel_name);
            if (index == -1) that.job.stats.push(stat);
            else that.job.stats[index] = stat;
          }
        } else {
          that.job[channel.chanel_id].page = -1;
        }
      })
      .catch((error) => console.log(error))
      .then(() => that.isLoading = false);
  }

  loadMore(page: any, channel: any, name: any = null) {
    if (page == -1) return;
    if (channel == 'search') channel = { chanel_id: 'search', chanel_name: null };
    if (!name) name = null;
    page++;
    this.getJobByChannel(channel, name, page);
  }

  channelList: any = [];

  getChannels() {
    this.editorService.getChannels(this.username).then((results: any) => {
      const sortedData = results.sort((a: any, b: any) => {
        const aHasMainChannel = a.tags?.includes('MAIN_CHANNEL');
        const bHasMainChannel = b.tags?.includes('MAIN_CHANNEL');
        return (aHasMainChannel === bHasMainChannel) ? 0 : (aHasMainChannel ? -1 : 1);
      });
      this.channelList = sortedData;
      for (let item of sortedData.slice(0, 100)) {
        this.job[item.chanel_id] = { results: [], page: 1 };
        this.getJobByChannel(item);
      }
    });
  }

  @ViewChild('searched') searched: ElementRef;

  jobSearchChange(event: any, value: any) {
    if (value) {
      this.viewType = 1;
      this.limit = 20;
      let channel = { chanel_id: 'search', chanel_name: null };
      let selectedOption = $(`#channels option[value="${value}"]`);
      if (selectedOption.length) {
        this.manualChannel = { chanel_id: selectedOption.val(), chanel_name: selectedOption.text() };
        value = null;
        this.searched.nativeElement.value = '';
      }
      this.job[channel.chanel_id] = { results: [], page: 1 };
      this.getJobByChannel(channel, value);
    } else this.manualChannel = {};
  }

  clearJobSearch() {
    this.manualChannel = {};
    if (!this.queryParam && this.reqType == 'views') {
      this.viewType = 0;
      this.limit = 5;
    } else if (this.reqType == 'views-crosspost') {
      this.viewType = 1;
    } else window.location.reload();
  }

  crosspostResults() {
    this.reqType = 'views-crosspost';
    this.viewType = 1;
    this.limit = 50;
    let channel = { chanel_id: 'search', chanel_name: null };
    this.job[channel.chanel_id] = { results: [], page: 1 };
    this.getJobByChannel(channel);
  }

  clearCrosspostResults() {
    this.reqType = 'views';
    if (!this.queryParam) {
      this.viewType = 0;
      this.limit = 5;
    } else window.location.reload();
  }

  reloadJob(item: any) {
    this.job[item.chanel_id] = { results: [], page: 1 };
    this.getJobByChannel(item);
  }

  isJobError(results: any) {
    return results ? results.some(x => (x.success != null && x.success != 1) || (x.upload_status != 0 && x.upload_status != 3)) : false;
  }

  isJobManual(results: any) {
    return results ? results.some(x => x.reup_config == null) : false;
  }

  metaItem: any = {};
  currentMetaItem: any = {};

  getMeta(item: any) {
    this.currentMetaItem = item;
    this.metaItem = {
      title: item.reup_config.title,
      description: item.reup_config.description,
      tags: item.reup_config.tags
    };
    let timestamp = '';
    let realTimestamp = '';
    let data = item.b_data?.includes('mix_data_real') ? item.b_data : item.music_data;
    if (data) {
      data = JSON.parse(data);
      let music = data.mix_data_real ? JSON.parse(data.mix_data_real) : data;
      let lastDurationMs = 0;
      let realDurationMs = 0;
      for (const [i, value] of music.entries()) {
        try {
          let isMissing = music[i].hasOwnProperty('success') && music[i].success === false;
          if (i == 0) {
            timestamp = `00:00:00 ${music[i].artist_name || ''} - ${music[i].song_name || music[i].name || ''}${isMissing ? ' ==> ⛔ MISSING' : ''}\n`;
            if (!isMissing) realTimestamp = `00:00:00 ${music[i].artist_name || ''} - ${music[i].song_name || music[i].name || ''}\n`;
            continue;
          }
          lastDurationMs += parseInt(music[i - 1].duration_ms || 180000);
          let time = new Date(lastDurationMs).toISOString().slice(11, 19);
          timestamp += `${time} ${music[i].artist_name || ''} - ${music[i].song_name || music[i].name || ''}${isMissing ? ' ==> ⛔ MISSING' : ''}\n`;
          if (!isMissing) {
            realDurationMs += parseInt(music[i - 1].duration_ms || 180000);
            let realTime = new Date(realDurationMs).toISOString().slice(11, 19);
            realTimestamp += `${realTime} ${music[i].artist_name || ''} - ${music[i].song_name || music[i].name || ''}\n`;
          }
        } catch (error) { }
      }
      this.metaItem.timestamp = timestamp;
      this.metaItem.real_timestamp = realTimestamp;
    }
  }

  genTimestampSRT() {
    let bdata = this.currentMetaItem.b_data?.includes('mix_data_real') ? this.currentMetaItem.b_data : this.currentMetaItem.music_data;
    if (!bdata) return;
    bdata = JSON.parse(bdata);
    let data = bdata.mix_data_real ? JSON.parse(bdata.mix_data_real) : bdata;
    let srtContent = '';
    let startTimeMs = 0;
    for (let i = 0; i < data.length; i++) {
      try {
        const entry = data[i];
        const isMissing = entry.hasOwnProperty('success') && entry.success === false;
        if (isMissing) continue;
        const nextStartTimeMs = startTimeMs + (entry.duration_ms || 180000);
        const start = new Date(startTimeMs).toISOString().slice(11, 23).replace('.', ',');
        const end = new Date(nextStartTimeMs - 1).toISOString().slice(11, 23).replace('.', ',');
        srtContent += `${i + 1}\n${start} --> ${end}\n${entry.artist_name ?? ''} - ${entry.song_name || entry.name || ''}\n\n`;
        startTimeMs = nextStartTimeMs;
      } catch (error) {}
    }

    const blob = new Blob([srtContent], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `caption-${Date.now()}.srt`;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  copyRealTimestamp() {
    navigator.clipboard.writeText(this.metaItem.real_timestamp);
  }

  getMusicStatus(item: any) {
    let result = '';
    let data = item.b_data?.includes('mix_data_real') ? item.b_data : item.music_data;
    if (data) {
      data = JSON.parse(data);
      if (data.mix_data_real) {
        let music = JSON.parse(data.mix_data_real);
        let success = music.filter((x) => x.success === true);
        result = `${success.length}/${music.length}`;
      } else result = `${data.length}/${data.length}`;
    }
    return result;
  }

  stopUpload(item: any) {
    const that = this;
    this.editorService.stopJob(item.id)
      .then(() => {
        item.status = 7;
        that.openSnackBar(`Job ${item.id} stopped`);
      })
      .catch((error) => {
        console.log(error);
        that.openSnackBar(`Stop job ${item.id} failed`);
      });
  }

  retryJob(item: any) {
    const that = this;
    const data = { id: item.id, status: 0 };
    let uri = encodeURIComponent(`${environment.magic}/job/update`);
    axios.post(`/pass-json/${uri}`, data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        item.status = 0;
        that.openSnackBar(`Retry job ${item.id} success`);
      })
      .catch((error) => console.log(error));
  }

  uploadNow(item: any) {
    const that = this;
    item.isUploading = true;
    let uri = encodeURIComponent(`${environment.music}/api/upload-run`);
    axios.post(`/pass-json/${uri}`, { studio_id: item.id }, {
        headers: { 'Content-Type': 'application/json', platform: 'moonmusic' }
      })
      .then((response) => {
        if (response.data?.success) {
          item.type = 3;
          that.openSnackBar(`Created upload job #${response.data.data?.id} for ${item.id}`);
        } else {
          item.isUploading = false;
          that.openSnackBar(`Upload job ${item.id} failed: ${response.data?.message}`);
        }
      })
      .catch((error) => {
        console.log(error);
        item.isUploading = false;
        that.openSnackBar(`Upload job ${item.id} failed: ${error.response?.data?.message || error.message}`);
      });
  }

  retryUpload(item: any) {
    const that = this;
    const uri = encodeURIComponent(`${environment.reup}/job/rerun/${item.id}`);
    axios.get(`/pass/${uri}`)
      .then((response) => {
        if (response.data?.success) item.upload_status = 0;
        that.openSnackBar(response.data?.message || `Retry upload ${item.id} success`);
      })
      .catch((error) => {
        console.log(error);
        that.openSnackBar(`Retry upload ${item.id} failed`);
      });
  }

  async getChannelMail(channel_id) {
    let result = null;
    try {
      let uri = encodeURIComponent(`${environment.music}/api/get/channel/info?channel_id=${channel_id}`);
      let response = await axios.get(`/pass/${uri}`);
      result = response.data.note;
    } catch (err) {
      console.log(err);
      result = null;
    }
    return result;
  }

  makeTaskList(value: any) {
    return JSON.stringify([
      {
        "script_name": "profile",
        "func_name": "login",
        "params": []
      },
      {
        "script_name": "upload",
        "func_name": "del_video",
        "params": [
          {
            "name": "video_source",
            "type": "json",
            "value": JSON.stringify(value)
          }
        ]
      }
    ]);
  }

  async deleteVideo(channel: any, item: any) {
    if (channel == 'search') {
      let note = await this.getChannelMail(item.channel_id);
      channel = { chanel_id: 'search', note, version: 1 };
    }
    if (channel.note && item.upload_log) {
      const that = this;
      let url = '';
      let formData = new FormData();
      if (true || channel.version == 1) {
        let uri = encodeURIComponent(`${environment.reup}/job/add`);
        url = `/pass/${uri}`;
        formData.append('gmail', channel.note);
        formData.append('task_list', this.makeTaskList([item.upload_log]));
        formData.append('run_time', '0');
        formData.append('type', '69');
        formData.append('piority', '10');
      } else {
        let uri = encodeURIComponent(`${environment.music}/api/video/delete`);
        url = `/pass/${uri}`;
        formData.append('data', JSON.stringify([{ channel_id: channel.chanel_id, video_id: item.upload_log }]));
      }
      axios.post(url, formData)
        .then((response) => {
          item.client_status = 0;
          let uri = encodeURIComponent(`${environment.magic}/job/client/status/${item.id}/0`);
          axios.get(`/pass/${uri}`).catch((error) => console.log(error));
        })
        .catch((error) => console.log(error));
    }
  }

  deleteData: any = {};

  async chkDeleteVideo(event: any, channel: any, item: any) {
    if (channel == 'search') {
      let note = await this.getChannelMail(item.channel_id);
      channel = { chanel_id: 'search', note };
    }
    if (!this.deleteData.hasOwnProperty(channel.chanel_id)) this.deleteData[channel.chanel_id] = { gmail: null, video_ids: [], job_ids: [] };
    let obj = this.deleteData[channel.chanel_id];
    obj.gmail = channel.note;
    if (event.target.checked) {
      obj.video_ids.push(item.upload_log);
      obj.job_ids.push(item.id);
    }
    else {
      obj.video_ids = obj.video_ids.filter(x => x != item.upload_log);
      obj.job_ids = obj.job_ids.filter(x => x != item.id);
    }
  }

  deleteVideos(channel: any) {
    if (channel == 'search') channel = { chanel_id: 'search', version: 1 };
    let obj = this.deleteData[channel.chanel_id];
    if (obj.gmail && obj.video_ids.length) {
      const that = this;
      let url = '';
      let formData = new FormData();
      if (true || channel.version == 1) {
        let uri = encodeURIComponent(`${environment.reup}/job/add`);
        url = `/pass/${uri}`;
        formData.append('gmail', obj.gmail);
        formData.append('task_list', this.makeTaskList(obj.video_ids));
        formData.append('run_time', '0');
        formData.append('type', '69');
        formData.append('piority', '10');
      } else {
        let uri = encodeURIComponent(`${environment.music}/api/video/delete`);
        url = `/pass/${uri}`;
        formData.append('data', JSON.stringify(obj.video_ids.map(e => {
          let data = { channel_id: channel.chanel_id, video_id: e };
          return data;
        })));
      }
      axios.post(url, formData)
        .then(async (response) => {
          that.openSnackBar(`Deleted ${obj.video_ids.length} videos`);
          for (let item of obj.job_ids) {
            let result = that.job[channel.chanel_id].results.find(x => x.id == item);
            if (result) result.client_status = 0;
            let uri = encodeURIComponent(`${environment.magic}/job/client/status/${item}/0`);
            await axios.get(`/pass/${uri}`).catch((error) => console.log(error));
          }
        })
        .catch((error) => console.log(error))
        .then(() => obj = { gmail: null, video_ids: [], job_ids: [] });
    }
  }

  scrollspy(chanel_id: any) {
    $(`#collapse${chanel_id}`)[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  archiveDrive(item: any) {
    const that = this;
    let uri = encodeURIComponent(`${environment.music}/studio/drive/save`);
    let payload = {
      username: this.username,
      channel_id: item.channel_id,
      channel_name: item.channel_name,
      result: item.result,
      studio_id: item.id
    };
    axios.post(`/pass-json/${uri}`, payload, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        if (response.data.status == 'success') that.openSnackBar(`Moving ${item.id} to archive`);
        else that.openSnackBar(`Error: ${response.data.message}`);
      })
      .catch((error) => console.log(error));
  }

  askErrorData: any = {};

  askError(item: any) {
    const that = this;
    this.askErrorData.isLoading = item.id;
    let uri = encodeURIComponent(`${environment.magic}/job/ask/error/${item.id}`);
    axios.get(`/pass/${uri}`)
      .then((response) => {
        Object.assign(that.askErrorData, response.data);
        $('#jobAskErrorModal').modal('show');
      })
      .catch((error) => console.log(error))
      .finally(() => that.askErrorData.isLoading = false);
  }
}

// PIPE //////////////////////////////////////
@Pipe({ name: 'round' })
export class RoundPipe {
  transform(number: any, digits: any) {
    return !isNaN(number) ? parseFloat(number).toFixed(digits) : null;
  }
}

@Pipe({ name: 'split' })
export class SplitPipe {
  transform(str: any, sep: any, index: any) {
    return (str != null && str != undefined && str.includes(sep)) ? str.split(sep)[index] : str;
  }
}

@Pipe({ name: 'numberFormat' })
export class NumberFormatPipe {
  transform(number: any, notation: any = 'compact') {
    return !isNaN(number) ?
      Intl.NumberFormat('en-US', {
        //@ts-ignore
        notation
      }).format(number) : null;
  }
}

@Pipe({ name: 'scheduleDate' })
export class ScheduleDatePipe {
  transform(schedule: any) {
    const days = new Set<number>();
    (schedule.seq_data || '').split(',').forEach(part => {
      const [a, b = a] = part.split('-').map(Number);
      for (let d = a; d <= b; d++) days.add(d);
    });
    if (schedule.seq_type == 'daily' || !days.size) return schedule.date;

    const date = new Date(schedule.date);
    if (isNaN(date.getTime())) return schedule.date;
    for (let i = 0; i < 366; i++, date.setDate(date.getDate() + 1)) {
      const value = schedule.seq_type == 'weekly' ? date.getDay() + 1 : date.getDate();
      if (days.has(value)) return date.toLocaleDateString('en-US');
    }
    return schedule.date;
  }
}
